import styled from 'styled-components';

import variables from '../../../styles/variables';

export const AnimatedLoader = styled.div`
  margin: auto 5%;
  width: 70px;
  text-align: center;

  &.small {
    margin: auto 10%;
    width: auto;
    text-align: left;
  }

  &.m-auto {
    margin: auto;
  }
`;

export const Bubble = styled.div`
  width: 12px;
  height: 12px;
  background-color: ${variables.colorRed};

  ${AnimatedLoader}.small & {
    width: 10px;
    height: 10px;
  }

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;

  &.bounce-1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  &.bounce-2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  &.bounce-3 {
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`;
